/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuInput } from '@neutron/react';

interface CSSProps {
  autoWidth?: boolean | undefined;
  centered?: boolean | undefined;
}

export const AttachedContainer = styled.div`
  // max-height: 0px;
  // transition: max-height 0.75s ease-out;
  // -webkit-transition: max-height 0.75s ease-out;
`;

export const SearchInput = styled(NeuInput)`
  min-height: 42px;
`;

export const ViewIssuesLabel = styled.div`
  font-style: normal;
  font-size: 1rem;
  line-height: 26px;
  color: var(--primary-60);
`;

export const ShowHideSpan = styled.span`
  font-size: 0.75rem;
`;

export const NoneAttachedLabel = styled.div`
  text-align: center !important;
  font-size: 1rem;
  font-weight: 500 !important;
`;

export const StyledDivider = styled.hr`
  width: 98%;
  margin-right: 1.5rem;
`;
